"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.validFonts = exports.validLinkColors = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
exports.validLinkColors = [
    'neutral70',
    'neutral100',
    'red50',
    'turquoise90',
    'darkTheme.teal100',
    'darkTheme.red100',
];
exports.validFonts = [
    'body',
    'labelSm',
    'metadata',
    'darkTheme.body',
    'darkTheme.label',
    'darkTheme.assistive',
];
var linkColor = function (isDisabled, selectedTheme, color) {
    var themedColor = (0, design_system_foundations_1.getPrefixedThemeColor)(color);
    var disabledColor = selectedTheme === 'dark' ? design_system_foundations_1.theme.color.neutral60 : design_system_foundations_1.theme.color.neutral70;
    return isDisabled ? disabledColor : themedColor;
};
var linkStyles = function (color, isDisabled, selectedTheme, font) {
    if (font === void 0) { font = ''; }
    return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  cursor: ", ";\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n\n  &:hover {\n    text-decoration: ", ";\n    color: ", ";\n  }\n\n  &:focus-visible {\n    border-radius: 2px;\n    outline: 1px solid ", ";\n    outline-offset: ", ";\n    text-decoration: underline;\n  }\n\n  &:link,\n  &:visited,\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"], ["\n  ", "\n  color: ", ";\n  cursor: ", ";\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n\n  &:hover {\n    text-decoration: ", ";\n    color: ", ";\n  }\n\n  &:focus-visible {\n    border-radius: 2px;\n    outline: 1px solid ", ";\n    outline-offset: ", ";\n    text-decoration: underline;\n  }\n\n  &:link,\n  &:visited,\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"])), selectedTheme === 'dark' ? (0, design_system_foundations_1.expandFontTheme)(font || 'darkTheme.body') : (0, design_system_foundations_1.expandFontTheme)(font), linkColor(isDisabled, selectedTheme, color), isDisabled ? 'not-allowed' : 'pointer', isDisabled ? 'none' : 'underline', isDisabled ? design_system_foundations_1.theme.color.neutral70 : design_system_foundations_1.theme.color[color], design_system_foundations_1.theme.color.turquoise90, design_system_foundations_1.theme.spacing.px4, linkColor(isDisabled, selectedTheme, color));
};
var externalLinkIconStyles = (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: ", ";\n"], ["\n  margin-left: ", ";\n"])), design_system_foundations_1.theme.spacing.px4);
exports.Link = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, isExternal = _a.isExternal, testId = _a.testId, color = _a.color, font = _a.font, children = _a.children, onClick = _a.onClick, isDisabled = _a.isDisabled, href = _a.href, _b = _a.role, role = _b === void 0 ? 'link' : _b, hideExternalIcon = _a.hideExternalIcon, rest = __rest(_a, ["className", "isExternal", "testId", "color", "font", "children", "onClick", "isDisabled", "href", "role", "hideExternalIcon"]);
    if (color && !exports.validLinkColors.includes(color)) {
        throw new Error("Invalid link color, valid colors are ".concat(exports.validLinkColors, " and you passed in ").concat(color, "."));
    }
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var themedColor = selectedTheme === 'dark' ? 'darkTheme.teal100' : 'turquoise90';
    var classes = (0, css_1.cx)(linkStyles(color !== null && color !== void 0 ? color : themedColor, isDisabled, selectedTheme, font), className, 'ds-link');
    return (react_1.default.createElement("a", __assign({ className: classes, ref: ref, target: isExternal ? '_blank' : undefined, rel: isExternal ? 'noopener noreferrer' : undefined, "data-testid": testId, role: role }, (href && !isDisabled && { href: href }), (onClick && !isDisabled && { onClick: onClick }), rest),
        children,
        isExternal && !hideExternalIcon ? (react_1.default.createElement(design_system_foundations_1.IconExternalLink, { className: externalLinkIconStyles, size: "sm", color: isDisabled ? 'neutral70' : themedColor })) : null));
});
exports.Link.displayName = 'Link';
var templateObject_1, templateObject_2;
